/** Guest journey (plan §2 S5): what a guest meets before the trip, in the order they meet
 *  it — self-registration, the pre-check-in form, the waiver texts notifications read, and
 *  the pre-trip checklist. One SectionCard (`tour#guest`); its blocks are anchors of their
 *  own (`tour#selfreg`, `#pre-check-in`, `#pre-trip-items` — the old Pre-check-in and
 *  Pre-trip items tab slugs land on theirs). Same DOM in view and edit mode. */
import { Box } from '@mui/material';

import { SectionCard } from '@/components/ReadView';

import { sectionAnchorId, TOUR_SECTIONS } from '../registry';

import { PreCheckBlock } from './PreCheckBlock';
import { PreTripItemsBlock } from './PreTripItemsBlock';
import { SelfregBlock } from './SelfregBlock';
import { WaiverTextsBlock } from './WaiverTextsBlock';

const SECTION = TOUR_SECTIONS.find((s) => s.id === 'guest')!;

function Rule() {
  return <Box sx={{ borderTop: 1, borderColor: 'divider' }} />;
}

export function GuestJourneyPanel() {
  return (
    <Box
      component="section"
      id={sectionAnchorId('guest')}
      tabIndex={-1}
      aria-label={SECTION.title}
      data-tour-section="guest"
      sx={{
        scrollMarginTop: 'var(--record-spine-height, 0px)',
        outline: 'none',
        borderRadius: 1,
        '&:focus-visible': { boxShadow: (t) => `0 0 0 2px ${t.palette.primary.main}` },
        '& > .MuiCard-root': { mb: 0 },
      }}
    >
      <SectionCard title={SECTION.title}>
        <Box sx={{ display: 'grid', gap: 1.5 }}>
          <SelfregBlock />
          <Rule />
          <PreCheckBlock />
          <Rule />
          <WaiverTextsBlock />
          <Rule />
          <PreTripItemsBlock />
        </Box>
      </SectionCard>
    </Box>
  );
}
